import React from 'react';
import { FormSelect } from 'react-bootstrap';

interface Props {
    totalRecords: number;
    filteredRecords: number;
    currentPageIndex: number;
    pageSize: number;
    visible?: boolean;
    handleChange: (page: number) => void;
}

export default function Pager({
    totalRecords,
    pageSize,
    handleChange,
    currentPageIndex,
    filteredRecords,
    visible = true,
}: Props) {
    //Rounding up total pages
    const totalPages = parseInt(Math.ceil(filteredRecords / pageSize).toFixed(0));
    const startingRecord = currentPageIndex * pageSize + 1;
    const endingRecord = startingRecord + pageSize - 1;

    //Creating array of pages based on total pages
    const pages = Array.from(Array(totalPages).keys());

    return (
        <div className='row text-muted'>
            <div className='col-sm-6'>
                {totalPages < 10 ? (
                    <nav
                        aria-label='Page navigation mb-3'
                        style={!visible ? { display: 'none' } : {}}
                    >
                        <ul className='pagination '>
                            {pages.map((page) => (
                                <li
                                    key={page}
                                    className={
                                        page === currentPageIndex
                                            ? 'page-item active'
                                            : 'page-item'
                                    }
                                >
                                    <button
                                        onClick={(e) => handleChange(page)}
                                        className='page-link'
                                        data-page={page}
                                    >
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                ) : (
                    <>
                        Ir a página:{' '}
                        <select
                            value={currentPageIndex}
                            onChange={(e) => handleChange(parseInt(e.target.value))}
                            className='form-select form-select-sm '
                            style={{ width: 75, display: 'inline' }}
                        >
                            {pages.map((page) => (
                                <option
                                    key={page}
                                    value={page}
                                    selected={page == currentPageIndex}
                                >
                                    {page + 1}
                                </option>
                            ))}
                        </select>
                    </>
                )}
            </div>
            <div className='col-sm-6'>
                <div className='justify-content-end' style={{ display: 'flex' }}>
                    {startingRecord} -{' '}
                    {endingRecord > filteredRecords ? filteredRecords : endingRecord}{' '}
                    de {filteredRecords} registros
                </div>
            </div>
        </div>
    );
}
